import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { BUILD_ID } from 'config/environment';
import { logger } from 'services';
import { isLocalhost } from 'utils/is-localhost';
import { isNitroEnvironment, isOrbitsEnvironment } from 'utils/is-nitro-env';

const dataDogIgnoredMessages = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  '<IntlProvider> needs to exist in the component ancestry',
  'db ready with version',
];
const dataDogIgnoredMessagePattern = new RegExp(
  dataDogIgnoredMessages.join('|'),
  'i',
);

export const initDatadog = (): void => {
  if (isLocalhost() || isOrbitsEnvironment()) {
    logger.log('Datadog disabled on localhost');

    return;
  }

  const config = {
    clientToken: 'pub85059e2b316001eb18784b68a4706f81',
    site: 'datadoghq.com',
    service: 'rocket-frontend',
    version: BUILD_ID,
    sampleRate: 100,
  };

  // datadogRum.init({
  //   ...config,
  //   applicationId: '4be5622c-c670-47e2-8dd6-3f0b23826c05',
  //   replaySampleRate: 0,
  //   trackInteractions: true,
  //   excludedActivityUrls: [
  //     /\/r.lr-in-prod.com$/,
  //     /\/backend.getbeamer.com$/,
  //     /\/.pusher.com$/,
  //   ],
  // });

  datadogLogs.init({
    ...config,
    forwardErrorsToLogs: true,
    beforeSend: ({ message }) => {
      if (dataDogIgnoredMessagePattern.test(message)) {
        return false;
      }

      return true;
    },
  });
  datadogLogs.addLoggerGlobalContext('build_id', BUILD_ID);
};

export const initDatadogRum = (): void => {
  // todo remove this check
  if (
    window.location.hostname.includes('leadsquared') ||
    window.location.hostname.includes('ushur') ||
    window.location.hostname.includes('clari5') ||
    isNitroEnvironment()
  ) {
    const config = {
      clientToken: 'pub85059e2b316001eb18784b68a4706f81',
      site: 'datadoghq.com',
      service: 'rocket-frontend',
      version: BUILD_ID,
    };

    datadogRum.init({
      ...config,
      applicationId: '4be5622c-c670-47e2-8dd6-3f0b23826c05',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      excludedActivityUrls: [
        /\/r.lr-in-prod.com$/,
        /\/backend.getbeamer.com$/,
        /\/.pusher.com$/,
      ],
    });

    datadogRum.startSessionReplayRecording();
  }
};

export const setDataDogIdentity = (userInfo): void =>
  datadogRum.setUser(userInfo);
